var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.125C11.5 9.25 8.96094 11.75 5.875 11.75C2.75 11.75 0.25 9.25 0.25 6.125C0.25 3.03906 2.75 0.5 5.875 0.5C8.96094 0.5 11.5 3.03906 11.5 6.125ZM6.5 3C6.5 2.6875 6.1875 2.375 5.875 2.375C3.76562 2.375 2.125 4.05469 2.125 6.125C2.125 6.47656 2.39844 6.75 2.75 6.75C3.0625 6.75 3.375 6.47656 3.375 6.125C3.375 4.75781 4.46875 3.625 5.875 3.625C6.1875 3.625 6.5 3.35156 6.5 3ZM4.625 19.25V12.9219C5.01562 12.9609 5.44531 13 5.875 13C6.26562 13 6.69531 12.9609 7.125 12.9219V19.25C7.125 19.9531 6.53906 20.5 5.875 20.5C5.17188 20.5 4.625 19.9531 4.625 19.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.9d7bd7483df868f62b5bbfc57334a141.svg";
export { ForwardRef as ReactComponent };